<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>三方订单上传</h3>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="批次">
          <el-input v-model="listQuery.id" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="三方平台">
          <el-select v-model="listQuery.platform" filterable placeholder="请选择三方平台">
            <el-option label="全部" value='' />
            <el-option v-for="item in platforms" :key="item.code" :label="item.name" :value='item.code' />
          </el-select>
        </el-form-item>
        <el-form-item label="上传时间">
          <el-date-picker v-model="createTime" value-format="timestamp" type="daterange" :picker-options="pickerOptions"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:230px"></el-date-picker>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
      </el-form>
      <el-button type="primary" icon="el-icon-upload" @click="() => { dialogVisible = true }">上传文件</el-button>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row
        style="width: 100%;margin-top: 20px;" :header-cell-style="tableHeader">
        <el-table-column label="批次" align="center" width="50">
          <template slot-scope="{row}">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="三方平台" align="center" width="150">
          <template slot-scope="{row}">
            <span>{{ getPlatformTxt(row.platform) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文件" align="center" width="300">
          <template slot-scope="{row}">
            <el-link @click="downloadFile(row.fileKey)" type="primary">{{ row.batchName || '--' }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="数据条数" align="center" width="80">
          <template slot-scope="{row}">
            <span>{{ row.batchCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成功数" align="center" width="80">
          <template slot-scope="{row}">
            <span>{{ row.successCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="失败数" align="center" width="80">
          <template slot-scope="{row}">
            <span>{{ row.failCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" width="420">
          <template slot-scope="{row}">
            <span>{{ row.remark || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="80">
          <template slot-scope="{row}">
            <span>{{ row.batchStatus ? '已完成' : '进行中' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上传时间" align="center" width="200">
          <template slot-scope="{row}">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作人" align="center" width="120">
          <template slot-scope="{row}">
            <span>{{ row.operator || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="{ row }">
            <div>
              <el-button type="text" @click="downloadFile(row.fileKeyWithFailReason)"
                style="color:#FF9900;">下载失败订单</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
        @pagination="getList" />
      <!-- 上传订单信息弹窗 -->
      <el-dialog title="上传订单信息" :visible.sync="dialogVisible" width="630px" :before-close="cancelDialog">
        <el-form :model="uploadQuery" :rules="rules" label-width="85px" ref="uploadRef">
          <el-form-item prop="platform" label="选择平台">
            <el-select v-model="uploadQuery.platform" filterable placeholder="请选择平台" class="selectWidth">
              <el-option v-for="item in platforms" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传Excel">
            <el-upload action="https://img.hetao101.com" accept=".xlsx, .xls" :show-file-list="true" :multile="false"
              :limit="2" :file-list="fileList" :on-change="handleSuccess" :before-upload="handleBeforeUpload"
              style="display: inline-block" ref="upload">
              <el-button slot="trigger" size="small" type="primary">上传Excel</el-button>
              <div slot="tip" class="el-upload__tip"><el-link type="danger">单次上传不超过1万条，</el-link><el-link
                  type="info">请使用标准模版上传文件，</el-link><el-link @click="downloadTemplate()" type="primary">下载模版</el-link>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="uploadQuery.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取消</el-button>
          <el-button type="primary" @click="confirmDialog()">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </power-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import PowerWrapper from "@/components/PowerWrapper";
import Pagination from "@/components/Pagination/index";

import { getThirdOrderUploadList, getThirdPlatforms, downloadThirdOrderUploadFile, uploadThirdOrderUploadFile } from "@/services/order";
import { commonConfig } from '@/utils/config'
import { timestampToDateTotal } from "@/utils/utils";
const { apiHetaoDomain } = commonConfig
const uploadQuery = {
  platform: '',
  remark: '',
  file: '',
}
export default {
  name: "thirdOrderUpload",
  components: {
    Pagination,
    PowerWrapper,
  },
  data() {
    return {
      CurrRole: "thirdOrderUpload",
      emptyText: '暂无数据',
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        platform: '',
      },
      formData: null,
      uploadQuery: {
        ...uploadQuery
      },
      fileList: [],
      list: [],
      rules: {
        platform: [
          { required: true, message: '请选择平台', trigger: 'change' },
        ],
      },
      dialogVisible: false,
      platforms: [],
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
      },
      total: 1,
    };
  },
  computed: {
    ...mapGetters([
    ]),
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.getThirdPlatforms();
    this.getList()
  },
  methods: {
    timestampToDate: t => timestampToDateTotal(t),
    getPlatformTxt(platform) {
      const list = this.platforms.concat([
        { code: "DirectImport", name: "表单导入" }
      ])
      const platformItem = list.find(item => item.code === platform);
      return platformItem?.name || '--';
    },
    async getThirdPlatforms() {
      try {
        const res = await getThirdPlatforms();
        const { errCode, errMsg, data } = res.data;
        if (errCode === 0) {
          this.platforms = data;
        } else {
          this.$message({ type: 'error', message: errMsg })
        }
      } catch (error) {
        this.$message({ type: 'error', message: '三方平台获取失败！请稍后重试' })
      }
    },
    async getList() {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const [startTime = '', endTime = ''] = createTime || [];
      Object.assign(listQuery, {
        startTime: new Date(startTime).setHours(0, 0, 0, 0) || '',
        endTime: new Date(endTime).setHours(23, 59, 59, 0) || ''
      });
      const orders = await getThirdOrderUploadList(listQuery);
      const {
        errCode,
        errMsg,
        data,
      } = orders.data;
      const { list, total } = data || {};
      console.log(' data ', data)
      if (errCode === 0) {
        Object.assign(this, {
          list,
          total
        });
      } else {
        if (errMsg) this.$message({ type: 'error', message: errMsg });
        Object.assign(this, {
          list: [],
          total: 0
        });
      }
      this.listLoading = false;
    },
    handleSearch() {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = 10;
      this.getList();
    },
    async downloadFile(url) {
      if (!url) {
        this.$confirm('无订单可下载');
        return
      }
      const params = {
        fileKey: url
      }
      try {
        const download = await downloadThirdOrderUploadFile(params);
        const { data, errCode, errMsg } = download.data;
        if (errCode === 0) {
          const downloadElement = document.createElement('a');
          downloadElement.href = data;
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
        } else {
          this.$message({ type: "error", message: errMsg || "导出失败" });
        }
      } catch (error) {
        this.$message({ type: "error", message: "导出失败" });
        console.log(error);
      }
    },
    async downloadTemplate() {
      try {
        const downloadElement = document.createElement('a');
        downloadElement.href = `${apiHetaoDomain}/ug-agent-back/v1/third-simple-batch/thirdSimpleTemplate`;
        downloadElement.download = '三方店铺导入模版.xls'; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
      } catch (error) {
        this.$message({ type: "error", message: "下载模版文件失败" });
        console.log(error);
      }
    },
    cancelDialog() {
      this.dialogVisible = false
      this.$refs.uploadRef.resetFields();
      this.$refs.upload.clearFiles()
      this.fileList = []
      this.uploadQuery = {
        ...uploadQuery
      }
    },
    async confirmDialog() {
      const that = this
      console.log(that.uploadQuery)
      that.$refs.uploadRef.validate(async valid => {
        if (valid) {
          const { file, platform, remark } = that.uploadQuery
          if (file) {
            const params = { platform, remark }
            const formData = new FormData()
            formData.append('file', file)
            try {
              this.loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.6)"
              });
              const res = await uploadThirdOrderUploadFile(params, formData)
              if (res.data.errCode === 0) {
                this.cancelDialog()
                this.getList()
                this.$message({ type: "success", message: "上传文件成功" });
              } else {
                this.$message({ type: "error", message: "上传文件失败:" + res.data.errMsg });
              }
              this.loading.close();
            } catch (error) {
              this.loading.close();
              this.$message({ type: "error", message: "上传文件失败" });
            }
          } else {
            this.$message({ type: "error", message: "请选择要上传的文件" });
          }
        } else {
          this.$message({ type: "error", message: "请检查必填项" });
        }
      })
    },
    handleSuccess(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.uploadQuery.file = file.raw
      this.fileList = [...fileList]
    },
    handleBeforeUpload(file) {
      // 读取文件为二进制数据
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   // e.target.result 包含文件的二进制数据
      //   const binaryData = e.target.result;
      //   // 处理二进制数据
      //   console.log('««««««««««')
      //   console.log(binaryData);
      //   this.uploadQuery.file = binaryData
      // };
      // reader.readAsArrayBuffer(file);
      // 阻止默认上传行为
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';

.icon-question {
  cursor: pointer;
}
</style>
